var StaticImage = /** @class */ (function () {
    function StaticImage(obj, id) {
        if (id) {
            this.id = id;
        }
        this.name = obj.name;
        this.image_url = obj.image_url;
    }
    Object.defineProperty(StaticImage.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticImage.prototype, "Name", {
        get: function () {
            return this.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticImage.prototype, "ImageUrl", {
        get: function () {
            return this.image_url;
        },
        enumerable: false,
        configurable: true
    });
    return StaticImage;
}());
export { StaticImage };
export function createStaticImage(obj, id) {
    return new StaticImage(obj, id);
}
export function createStaticImages(rawStaticImages) {
    var staticImages = [];
    var rawStaticImagesData = rawStaticImages.data;
    for (var _i = 0, rawStaticImagesData_1 = rawStaticImagesData; _i < rawStaticImagesData_1.length; _i++) {
        var rawStaticImage = rawStaticImagesData_1[_i];
        var staticImage = createStaticImage(rawStaticImage.attributes, rawStaticImage.id);
        staticImages.push(staticImage);
    }
    return staticImages;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/staticImage/staticImage.ts
// module id = 477
// module chunks = 0